export enum SortDirectionDto {
  ASC = 'ASC',
  DESC = 'DESC',
}
